var map = {
	"./en/common.json": [
		251,
		251
	],
	"./en/settings.json": [
		815,
		815
	],
	"./es/common.json": [
		266,
		266
	],
	"./es/settings.json": [
		582,
		582
	],
	"./fr/common.json": [
		258,
		258
	],
	"./fr/settings.json": [
		150,
		150
	],
	"./it/common.json": [
		669,
		669
	],
	"./it/settings.json": [
		385,
		385
	],
	"./ja/common.json": [
		625,
		625
	],
	"./ja/settings.json": [
		789,
		789
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 631;
module.exports = webpackAsyncContext;